import * as ListingBffRepository from './listingBffRepository';
import mapSearchResultTranslator from './mapSearchResultTranslator';

export default (searchConditionQuery, featureFlags) => (
  ListingBffRepository.mapSearchListings(searchConditionQuery, featureFlags)
    .then(data => mapSearchResultTranslator(data))
    .catch(e => Promise.reject(new Error(`An error occurred during the request to the server: ${e}`)))
);
